// modules
import React from 'react'

// components
import Icon from 'src/components/Icon'

const UnexpectedError = () => (
  <div className="unexpected-error">
    <Icon className="icon" name="exclamation-circle" />

    <h1>Oops! Something went wrong.</h1>

    <span>
      Please{' '}
      <a
        href="#"
        onClick={(e) => {
          e.preventDefault()
          window.location.reload(true)
        }}>
        click here
      </a>
      , if problem persists please contact with{' '}
      <a href="mailto:admin@emmacare.com?subject=Portal">Administrator</a>
    </span>
  </div>
)

export default UnexpectedError
